import { Component, OnInit } from '@angular/core';
import { PaymenttermService } from '../setup/paymentterm/paymentterm.service';
import { MessageService } from 'primeng/api';
import { PaymentmethodService } from '../setup/paymentmethod/paymentmethod.service';
import { CustomRuleService } from './custom-rule.service';
import { ObjectNames, Severity, Status } from '../constants/constants';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppMainComponent } from '../../../app.main.component';
import { TitleCasePipe } from '@angular/common';
import { AppMainService } from '../../../app-main.service';
import { debounceTime, BehaviorSubject } from "rxjs";

@Component({
  selector: 'app-custom-rule',
  templateUrl: './custom-rule.component.html',
  styleUrls: ['./custom-rule.component.scss']
})
export class CustomRuleComponent implements OnInit {

  disabledChannel: boolean = false;
  rules = [];
  displayAddRule = false;
  addEditRule;
  allModules = [];
  selectedModule;
  allChannels = [];
  selectedChannel;
  allDefaults = []
  selectedDefault = [];
  selectedPreferred;
  sameFormat: boolean;
  allPaymentTerms: any[] = [];
  allPaymentTermsDD: any = [];
  isDisabled: boolean = false;
  allPaymentMethods = [];
  allPaymentMethodsDD: any = [];
  option = 'new';
  displayVendorTB = false;
  selectedVendors = [];
  ruleTypes = [];
  ruleOptions = ObjectNames.customConstants.Custom_Rule_Options;
  checked: boolean;
  selectedType;
  headerType;
  isEdit = false;
  selectedDefault2 = [];
  selectedPreferred2 = [];
  isPaymentTerm: boolean;
  savedRule;
  isPaymentMethod: boolean;
  selectedOption: string = '';
  customRuleForm: FormGroup;
  isAdd: boolean = true;
  //vendors
  totalRecords: number = 0;
  allVendorsData = [];
  vendorsData = [];
  pageNumber: number = 1;
  first: number = 0;
  pageSize: number = 15;
  searchValue: string = '';
  searchColumns: string = '';
  modelChanged = new BehaviorSubject<string>('');
  noPOFindOrLoadingText: string = '';
  //Accounts
  displayAccountTB: boolean = false;
  selectedAccounts = [];
  allAccountsData = [];
  accountsData = [];
  channelId: number = 0;

  constructor(private paymentTermService: PaymenttermService, private paymentMethodService: PaymentmethodService,
    private customRuleService: CustomRuleService, private fb: FormBuilder, private app: AppMainComponent,
    private messageService: MessageService, private titlecasePipe: TitleCasePipe, private appService: AppMainService) {
    this.modelChanged.pipe(
      debounceTime(700))
      .subscribe((type) => {
        if (type == 'vendor') {
          this.onGlobalSearch();
        } else if (type == 'account') {
          this.onAccountGlobalSearch();
        }
      })
  }

  ngOnInit(): void {
    this.appService.isShowSpinner('customrule');
    this.loadCustomRules();
    this.loadModules();
    this.loadGroups();
    // this.loadPaymentMethod();
    // this.loadPaymentTerm();
    this.customRuleForm = this.fb.group({
      id: [0],
      createdSource: [this.app.userIP],
      updatedSource: [this.app.userIP],
      createdBy: [this.app.userId],
      updatedBy: [this.app.userId],
      createdDate: [new Date().toISOString()],
      updatedDate: [new Date().toISOString()],
      moduleId: ['', [Validators.required]],
      moduleName: [''],
      channelId: [null],
      channel: [''],
      typeId: [null, [Validators.required]],
      type: [null],
      ruleApplyTypeId: [null],
      statusId: [Status.ACTIVE],
      organizationId: [this.app.companyId],
      defaultSelected: ['', [Validators.required]],
      preferredDefault: ['', [Validators.required]]
    })
  }

  changed(event, type) {
    this.modelChanged.next(type);
  }

  onGlobalSearch() {
    this.first = 0;
    this.pageNumber = 1;
    this.loadVendors(this.pageNumber, this.pageSize, this.searchColumns, this.searchValue);
  }

  onAccountGlobalSearch() {
    this.first = 0;
    this.pageNumber = 1;
    this.loadAccounts(this.pageNumber, this.pageSize, this.channelId, this.searchColumns, this.searchValue);
  }


  loadCustomRules() {
    this.appService.isShowSpinner('customrule');
    this.customRuleService.getAllCustomRules().subscribe(rules => {
      if (rules) {
        this.appService.isHideSpinner('customrule');
        this.rules = rules;
      }
    })
  }

  loadGroups() {
    this.customRuleService.getGroups().subscribe(groups => {
      const customGroupRule = groups.filter(group => group.name == 'Custom Rules Group')[0];
      this.loadTypes(customGroupRule.id);
    })
  }

  loadTypes(groupId) {
    this.customRuleService.getCustomTypes(groupId).subscribe(types => {
      this.ruleTypes = types;
    })
  }

  loadModules() {
    this.customRuleService.getAllModules().subscribe(modules => {
      this.allModules = modules.filter(m => (m.name == 'Account' || m.name == 'Vendor') && m.typeId==ObjectNames.customRulesConstant.moduleTypeId);
    })
  }

  loadConfigurations(action?) {
    if (this.customRuleForm.controls['moduleId']?.value?.name == 'Account') {
      this.customRuleForm.controls['channelId'].setValue(null);
      const moduleId = this.customRuleForm.controls['moduleId']?.value?.id;
      this.disabledChannel = false;
      this.customRuleService.getChannelByModuleId(moduleId).subscribe(ch => {
        this.allChannels = ch;
        this.customRuleForm.controls['channelId'].setValidators([Validators.required]);
        this.customRuleForm.controls['channelId'].updateValueAndValidity();
        if (action) {
          const filteredChannel = this.allChannels.filter(channel => channel.id == this.savedRule?.channelId)[0];
          this.customRuleForm.controls['channelId'].setValue(filteredChannel);
        }
      })
    } else {
      this.disabledChannel = true;
      this.customRuleForm.controls['channelId'].setValue(0);
    }
    this.loadAPIs();
  }

  getRulebyId(id) {
    this.customRuleService.getCustomRuleById(id).subscribe(rule => {
      this.customRuleForm.patchValue(rule);
      const filteredModule = this.allModules.filter(module => module.id == rule?.moduleId)[0];
      this.customRuleForm.controls['moduleId'].setValue(filteredModule);
      const filteredType = this.ruleTypes.filter(type => type.id == rule?.typeId)[0];
      this.customRuleForm.controls['typeId'].setValue(filteredType);
      this.loadAPIs(rule);
    })
  }

  loadAPIs(rule?) {
    this.customRuleForm.controls['defaultSelected'].setValue([]);
    this.customRuleForm.controls['preferredDefault'].setValue(null);
    const termIndex = this.customRuleForm?.controls['moduleId']?.value?.name === 'Account' ? 0 : 2;
    const methodIndex = this.customRuleForm?.controls['moduleId']?.value?.name === 'Account' ? 1 : 3;
    if (this.customRuleForm?.controls['typeId']?.value?.name === 'Payment Method') {
     this.loadPaymentMethod(methodIndex,rule);
    } else {
       this.loadPaymentTerm(termIndex,rule);
    }
  }

  loadPaymentTerm(index: number,rule?) {
    this.paymentTermService.getPaymentTermList(index, true).subscribe((terms) => {
      for (let term of terms) {
        term.inactive = (term.statusId == 1 ? false : true);
      }
      this.allPaymentTerms = terms;
      this.allPaymentTermsDD = this.allPaymentTerms?.filter(term => term.statusId == Status.ACTIVE);
      if(rule){
        this.editRule(rule);
      }
    })
  }

  loadPaymentMethod(index: number,rule?) {
    this.paymentMethodService.getPaymentMrthodList(index, true).subscribe((methods) => {
      for (let method of methods) {
        method.inactive = (method.statusId == 1 ? false : true);
      }
      this.allPaymentMethods = methods;
      this.allPaymentMethodsDD = this.allPaymentMethods?.filter(method => method.statusId == Status.ACTIVE);
      if(rule){
        this.editRule(rule);
      }
    })
  }

  setPaymentMethods(paymentMethods) {
    const activePaymentMethods = this.allPaymentMethods?.filter(method => method.statusId == Status.ACTIVE);
    //Check for Inactive records
    const res = paymentMethods?.filter(x => !activePaymentMethods?.some(y => y.id == x.paymentMethodId));
    if (res?.length > 0) {
      res.forEach(element => {
        const record = this.allPaymentMethods?.filter(method => method.id == element.paymentMethodId)[0];
        if(record){
          activePaymentMethods.push(record);
        }
      });
    }
    return activePaymentMethods;
  }

  setPaymentTerms(paymentTerms) {
    const activePaymentTerms = this.allPaymentTerms?.filter(term => term.statusId == Status.ACTIVE);
    //Check for Inactive records
    const res = paymentTerms?.filter(x => !activePaymentTerms?.some(y => y.id == x.paymentTermId));
    if (res?.length > 0) {
      res.forEach(element => {
        const record = this.allPaymentTerms?.filter(term => term.id == element.paymentTermId)[0];
        if(record){
          activePaymentTerms.push(record);
        }
      });
    }
    return activePaymentTerms;
  }

  cancelDialog() {
    this.displayVendorTB = false;
    this.displayAccountTB = false;
    this.isEdit = false;
    this.first = 0;
  }

  setDefaultPaymentTerms(defaultTerm) {
    const term = [];
    defaultTerm.forEach(element => {
      const filteredTerm = this.allPaymentTerms.filter(term => term.id == element.paymentTermId)[0];
      term.push(filteredTerm);
    });
    return term;
  }

  setPreferredTerm(preferred) {
    preferred.forEach(element => {
      if (element.isDefault) {
        const filteredTerm = this.allPaymentTerms.filter(term => term.id == element.paymentTermId)[0];
        return filteredTerm;
      }
    });
  }

  setPreferredMethod(preferred) {
    preferred.forEach(element => {
      if (element.isDefault) {
        const filteredMethod = this.allPaymentMethods.filter(method => method.id == element.paymentMethodId)[0];
        return filteredMethod;
      }
    });
  }

  setDefaultPaymentMethods(defaultMethod) {
    const method = [];
    defaultMethod.forEach(element => {
      const filteredMethod = this.allPaymentMethods.filter(method => method.id == element.paymentMethodId)[0];
      method.push(filteredMethod);
    });
    return method;
  }


  loadVendors(pageNumber, pageSize, searchColumns, searchValue) {
    this.appService.isShowSpinner('customrule');
    this.allPaymentMethodsDD = this.allPaymentMethods?.filter(method => method.statusId == Status.ACTIVE);
    this.allPaymentTermsDD = this.allPaymentTerms?.filter(term => term.statusId == Status.ACTIVE);
    this.customRuleService.getAllVendors(pageNumber, pageSize, searchColumns, searchValue).then(vendor => {
      let { vendors, headers } = vendor;
      vendors = vendors == null ? [] : vendors;
      headers = headers == null ? [] : headers;
      this.totalRecords = headers['TotalCount'];
      this.allVendorsData = [];
      this.vendorsData = [];
      if (vendors.length > 0) {
        for (let l of vendors) {
          let streetName;
          let cityName;
          let stateName;

          for (let add of l.vendorAddresses) {
            if (add.address?.isDefault) {
              streetName = add.address?.streetAddress1 + ' ' + add.address?.streetAddress2;
              cityName = add.address?.city?.name;
              stateName = add.address?.state?.name;
            }
          }
          let eachVendor = {
            id: l.id,
            name: l.vendorName,
            street: streetName,
            city: cityName,
            state: stateName,
            paymentTerms: this.setPaymentTerms(l.vendorPaymentTerm),
            defaultPaymentTerms: this.setDefaultPaymentTerms(l.vendorPaymentTerm),
            preferredPayment: l.vendorPaymentTerm?.filter(t => t.isDefault == true).map(term => term.paymentTermId)[0],
            preferredPaymentName: l.vendorPaymentTerm?.filter(t => t.isDefault == true).map(term => term.paymentMethodTerm)[0],
            paymentMethods: this.setPaymentMethods(l.vendorPaymentMethod),
            defaultPaymentMethods: this.setDefaultPaymentMethods(l.vendorPaymentMethod),
            preferredMethod: l.vendorPaymentMethod?.filter(t => t.isDefault == true).map(method => method.paymentMethodId)[0],
            preferredMethodName: l.vendorPaymentMethod?.filter(t => t.isDefault == true).map(method => method.paymentMethodMethod)[0],
            isChecked: false
          }
          this.allVendorsData.push(eachVendor);
        }
        this.vendorsData = JSON.parse(JSON.stringify(this.allVendorsData));
        this.vendorsData.forEach((element: any) => {
          const alreadyChecked: any = this.selectedVendors.filter((vendor: any) => vendor.id == element.id)[0];
          if (alreadyChecked) {
            element.isChecked = true;
            element.defaultPaymentTerms = alreadyChecked.defaultPaymentTerms,
              element.preferredPayment = alreadyChecked.preferredPayment,
              element.preferredPaymentName = alreadyChecked.preferredPaymentName,
              element.defaultPaymentMethods = alreadyChecked.defaultPaymentMethods,
              element.preferredMethod = alreadyChecked.preferredMethod,
              element.preferredMethodName = alreadyChecked.preferredMethodName
          }
        });
        this.appService.isHideSpinner('customrule');
      } else {
        this.totalRecords = 0;
        this.appService.isHideSpinner('customrule');
        this.noPOFindOrLoadingText = 'No Vendors found.';
      }
    })
  }

  getData(event) {
    this.pageNumber = (event.first / event.rows) + 1;
    this.first = event.first;
    this.loadVendors(this.pageNumber, this.pageSize, this.searchColumns, this.searchValue);
  }

  loadAccounts(pageNumber, pageSize, channelId, searchColumns, searchValue) {
    this.appService.isShowSpinner('customrule');
    this.allPaymentMethodsDD = this.allPaymentMethods?.filter(method => method.statusId == Status.ACTIVE);
    this.allPaymentTermsDD = this.allPaymentTerms?.filter(term => term.statusId == Status.ACTIVE);
    this.customRuleService.getAllAccounts(pageNumber, pageSize, channelId, searchColumns, searchValue).then(account => {
      let { accounts, headers } = account;
      accounts = accounts == null ? [] : accounts;
      headers = headers == null ? [] : headers;
      this.totalRecords = headers['TotalCount'];
      this.allAccountsData = [];
      this.accountsData = [];
      if (accounts.length > 0) {
        for (let l of accounts) {
          let streetName;
          let cityName;
          let stateName;

          for (let add of l.accountAddresses) {
            if (add.address?.isDefault) {
              streetName = add.address?.streetAddress1 + ' ' + add.address?.streetAddress2;
              cityName = add.address?.city?.name;
              stateName = add.address?.state?.name;
            }
          }
          let eachAccount = {
            id: l.id,
            name: l.businessName,
            street: streetName,
            city: cityName,
            state: stateName,
            paymentTerms: this.setPaymentTerms(l.accountPaymentTerms),
            defaultPaymentTerms: this.setDefaultPaymentTerms(l.accountPaymentTerms),
            preferredPayment: l.accountPaymentTerms?.filter(t => t.isDefault == true).map(term => term.paymentTermId)[0],
            preferredPaymentName: l.accountPaymentTerms?.filter(t => t.isDefault == true).map(term => term.paymentTermName)[0],
            paymentMethods: this.setPaymentMethods(l.accountPaymentMethods),
            defaultPaymentMethods: this.setDefaultPaymentMethods(l.accountPaymentMethods),
            preferredMethod: l.accountPaymentMethods?.filter(t => t.isDefault == true).map(method => method.paymentMethodId)[0],
            preferredMethodName: l.accountPaymentMethods?.filter(t => t.isDefault == true).map(method => method.paymentMethodName)[0],
            isChecked: false
          }
          this.allAccountsData.push(eachAccount);
        }
        this.accountsData = JSON.parse(JSON.stringify(this.allAccountsData));
        this.accountsData.forEach((element: any) => {
          const alreadyChecked: any = this.selectedAccounts.filter((account: any) => account.id == element.id)[0];
          if (alreadyChecked) {
            element.isChecked = true;
            element.defaultPaymentTerms = alreadyChecked.defaultPaymentTerms,
              element.preferredPayment = alreadyChecked.preferredPayment,
              element.preferredPaymentName = alreadyChecked.preferredPaymentName,
              element.defaultPaymentMethods = alreadyChecked.defaultPaymentMethods,
              element.preferredMethod = alreadyChecked.preferredMethod,
              element.preferredMethodName = alreadyChecked.preferredMethodName
          }
        });
        this.appService.isHideSpinner('customrule');
      } else {
        this.totalRecords = 0;
        this.appService.isHideSpinner('customrule');
        this.noPOFindOrLoadingText = 'No Accounts found.';
      }
    })
  }

  getAccountsData(event) {
    this.pageNumber = (event.first / event.rows) + 1;
    this.first = event.first;
    this.loadAccounts(this.pageNumber, this.pageSize, this.channelId, this.searchColumns, this.searchValue);
  }

  addRule() {
    this.addEditRule = "Add Rule";
    // this.allPaymentMethodsDD = this.allPaymentMethods?.filter(method=> method.statusId==Status.ACTIVE);
    // this.allPaymentTermsDD = this.allPaymentTerms?.filter(term=> term.statusId==Status.ACTIVE);
    this.disabledChannel = false;
    this.isDisabled = false;
    this.savedRule = null;
    this.isAdd = true;
    this.customRuleForm = this.fb.group({
      id: [0],
      createdSource: [this.app.userIP],
      updatedSource: [this.app.userIP],
      createdBy: [this.app.userId],
      updatedBy: [this.app.userId],
      createdDate: [new Date().toISOString()],
      updatedDate: [new Date().toISOString()],
      moduleId: ['', [Validators.required]],
      moduleName: [''],
      channelId: [null],
      channel: [''],
      typeId: [null, [Validators.required]],
      type: [null],
      ruleApplyTypeId: [this.ruleOptions[2].id],
      statusId: [Status.ACTIVE],
      organizationId: [this.app.companyId],
      defaultSelected: ['', [Validators.required]],
      preferredDefault: ['', [Validators.required]]
    })
    this.displayAddRule = true;
  }

  editRule(rule) {
    this.addEditRule = 'Edit Rule';
    this.allPaymentMethodsDD = this.allPaymentMethods?.filter(method => method.statusId == Status.ACTIVE);
    this.allPaymentTermsDD = this.allPaymentTerms?.filter(term => term.statusId == Status.ACTIVE);
    this.disabledChannel = false;
    this.isDisabled = false;
    this.isAdd = false;
    //this.customRuleService.getCustomRuleById(id).subscribe(rule => {
      this.savedRule = rule;
      // this.customRuleForm.patchValue(rule);
      // const filteredModule = this.allModules.filter(module => module.id == this.savedRule?.moduleId)[0];
      // this.customRuleForm.controls['moduleId'].setValue(filteredModule);
      this.loadConfigurations('edit');
      // const filteredType = this.ruleTypes.filter(type => type.id == this.savedRule?.typeId)[0];
      // this.customRuleForm.controls['typeId'].setValue(filteredType);
      if (this.customRuleForm.controls['typeId']?.value?.name == 'Payment Term') {
        //Check for Inactive records
        const res = this.savedRule?.preferredPaymentTerm?.filter(x => !this.allPaymentTermsDD?.some(y => y.id == x.paymentTermId));
        if (res?.length > 0) {
          res.forEach(element => {
            const record = this.allPaymentTerms?.filter(method => method.id == element.paymentTermId)[0];
            this.allPaymentTermsDD.push(record);
          });
        }

        const filteredDefaultSelection = [];
        this.savedRule?.preferredPaymentTerm?.forEach(element => {
          const term = this.allPaymentTermsDD?.filter(t => t.id == element.paymentTermId)[0];
          filteredDefaultSelection.push(term);
        });
        this.customRuleForm.controls['defaultSelected'].setValue(filteredDefaultSelection);
        const preferedPaymntTerm = this.savedRule?.preferredPaymentTerm.filter(m => m.isPreferred == true)[0];
        const filteredPreferredSelection = this.customRuleForm.controls['defaultSelected'].value?.filter(selection =>
          selection.id == preferedPaymntTerm.paymentTermId)[0];
        this.customRuleForm.controls['preferredDefault'].setValue(filteredPreferredSelection);
      } else if (this.customRuleForm.controls['typeId']?.value?.name == 'Payment Method') {
        //Check for Inactive records
        const res = this.savedRule?.preferredPaymentMethod?.filter(x => !this.allPaymentMethodsDD?.some(y => y.id == x.paymentMethodId));
        if (res?.length > 0) {
          res.forEach(element => {
            const record = this.allPaymentMethods?.filter(method => method.id == element.paymentMethodId)[0];
            this.allPaymentMethodsDD.push(record);
          });
        }

        const filteredDefaultSelection = [];
        this.savedRule?.preferredPaymentMethod?.forEach(element => {
          const method = this.allPaymentMethodsDD?.filter(t => t.id == element.paymentMethodId)[0];
          filteredDefaultSelection.push(method);
        });
        this.customRuleForm.controls['defaultSelected'].setValue(filteredDefaultSelection);
        const preferedPaymentMethod = this.savedRule?.preferredPaymentMethod.filter(m => m.isPreferred == true)[0];
        const filteredPreferredSelection = this.customRuleForm.controls['defaultSelected'].value?.filter(selection =>
          selection.id == preferedPaymentMethod?.paymentMethodId)[0];
        this.customRuleForm.controls['preferredDefault'].setValue(filteredPreferredSelection);
      }
      this.displayAddRule = true;
    //})
  }

  setPreferredPaymentMethod(value) {
    const methods = [];
    if (value.defaultSelected?.length > 0) {
      value.defaultSelected.forEach(element => {
        const methodEach = {
          id: (this.savedRule?.preferredPaymentMethod?.filter(t => t.paymentMethodId == element.id).map(method => method.id)[0] ?
            this.savedRule?.preferredPaymentMethod?.filter(t => t.paymentMethodId == element.id).map(method => method.id)[0] : 0),
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          paymentMethodId: element.id,
          isPreferred: (element.id == value.preferredDefault?.id ? true : false),
          customRulesId: (this.savedRule ? this.savedRule?.id : 0),
          organizationId: this.app.companyId,
          statusId: Status.ACTIVE
        }
        methods.push(methodEach);
      });
    }
    return methods;
  }

  setPreferredPaymentTerm(value) {
    const terms = [];
    if (value.defaultSelected?.length > 0) {
      value.defaultSelected.forEach(element => {
        const termEach = {
          id: (this.savedRule?.preferredPaymentTerm?.filter(t => t.paymentTermId == element.id).map(term => term.id)[0] ?
            this.savedRule?.preferredPaymentTerm?.filter(t => t.paymentTermId == element.id).map(term => term.id)[0] : 0),
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          paymentTermId: element.id,
          isPreferred: (element.id == value.preferredDefault?.id ? true : false),
          customRulesId: (this.savedRule ? this.savedRule?.id : 0),
          organizationId: this.app.companyId,
          statusId: Status.ACTIVE
        }
        terms.push(termEach);
      });
    }
    return terms;
  }

  setValue(event) {
    if (this.customRuleForm.controls['preferredDefault'].value?.id == event.itemValue?.id) {
      this.customRuleForm.controls['preferredDefault'].setValue('');
    }
  }

  validateCustomRuleCombination(value) {
    this.isDisabled = true;
    if (this.isAdd) {
      this.customRuleService.checkCustomRuleCombination(value.moduleId?.id, (value.channelId != 0 ? value.channelId?.id : value.channelId), value.typeId?.id).subscribe((res) => {
        if (res.item1 == 200) {
          this.save(value);
        } else if (res.item1 == 500) {
          this.isDisabled = false;
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: res.item2 });
        }
      })
    } else {
      this.save(value);
    }
  }

  save(value) {
    value.channel = this.allChannels.filter(c => c.id == value.channelId?.id).map(channel => channel.name)[0];
    value.moduleName = this.allModules.filter(m => m.id == value.moduleId?.id).map(module => module.name)[0];
    value.channelId = value.channelId?.id;
    value.moduleId = value.moduleId?.id;
    value.type = JSON.parse(JSON.stringify(value.typeId));
    value.typeId = value.typeId?.id;
    value.preferredPaymentMethod = (this.ruleTypes.filter(t => t.id == value.typeId).map(type => type.name)[0] == 'Payment Method' ?
      this.setPreferredPaymentMethod(value) : []);
    value.preferredPaymentTerm = (this.ruleTypes.filter(t => t.id == value.typeId).map(type => type.name)[0] == 'Payment Term' ?
      this.setPreferredPaymentTerm(value) : []);
    value.preferredDefault = '';
    value.defaultSelected = '';
    if (this.isAdd) {
      this.customRuleService.addCustomRule(value).then(() => {
        this.displayAddRule = false;
        this.isDisabled = false;
        this.loadCustomRules();
        this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: "Custom Rule added successfully..." });
      })
        .catch(() => {
          this.isDisabled = false;
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: "Error in saving data..." });
        });
    } else {
      this.customRuleService.updateCustomRule(value).then(() => {
        this.displayAddRule = false;
        this.isDisabled = false;
        this.loadCustomRules();
        this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: "Custom Rule updated successfully..." });
      })
        .catch((error) => {
          this.isDisabled = false;
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: "Error in saving data..." });
        });
    }
  }

  loadAPIDataByType(module, type, channelId) {
    const termIndex = module === 'Account' ? 0 : 2;
    const methodIndex = module === 'Account' ? 1 : 3;
    if (type === 'Payment Method') {
     this.loadPaymentMethod(methodIndex);
    } else {
     this.loadPaymentTerm(termIndex);
    }
    // Ensure showAllVendors is called only after the previous data load completes
    this.showAllVendors(module, type, channelId);
  }

  showAllVendors(module, type, channelId) {
    if (module == 'Vendor') {
      this.selectedVendors = [];
      this.isEdit = false;
      if (type == 'Payment Term') {
        this.headerType = "Default Payment Term";
        this.isPaymentTerm = true;
        this.isPaymentMethod = false;
        this.first = 0;
        this.pageNumber = 1;
        this.searchValue = '';
        this.loadVendors(this.pageNumber, this.pageSize, this.searchColumns, this.searchValue);
      } else if (type == 'Payment Method') {
        this.headerType = "Default Payment Method";
        this.isPaymentMethod = true;
        this.isPaymentTerm = false;
        this.first = 0;
        this.pageNumber = 1;
        this.searchValue = '';
        this.loadVendors(this.pageNumber, this.pageSize, this.searchColumns, this.searchValue);
      }
      this.displayVendorTB = true;
    } else {
      this.selectedAccounts = [];
      this.isEdit = false;
      this.channelId = channelId;
      if (type == 'Payment Term') {
        this.headerType = "Default Payment Term";
        this.isPaymentTerm = true;
        this.isPaymentMethod = false;
        this.first = 0;
        this.pageNumber = 1;
        this.searchValue = '';
        this.loadAccounts(this.pageNumber, this.pageSize, channelId, this.searchColumns, this.searchValue);
      } else if (type == 'Payment Method') {
        this.headerType = "Default Payment Method";
        this.isPaymentMethod = true;
        this.isPaymentTerm = false;
        this.first = 0;
        this.pageNumber = 1;
        this.searchValue = '';
        this.loadAccounts(this.pageNumber, this.pageSize, channelId, this.searchColumns, this.searchValue);
      }
      this.displayAccountTB = true;
    }
  }

  onChangeCustomRule(vendor) {
    if ((this.isPaymentMethod && vendor.defaultPaymentMethods.length > 0) || (this.isPaymentTerm && vendor.defaultPaymentTerms.length > 0)) {
      vendor.isChecked = true;
      vendor.preferredPaymentName = this.allPaymentTerms?.filter(t => t.id == vendor.preferredPayment).map(term => term.name)[0];
      vendor.preferredMethodName = this.allPaymentMethods?.filter(m => m.id == vendor.preferredMethod).map(method => method.name)[0];
      const exists = this.selectedVendors?.filter((v: any) => v.id == vendor.id)[0];
      if (exists) {
        const index = this.selectedVendors.indexOf(vendor);
        this.selectedVendors.splice(index, 1);
        this.selectedVendors.push(vendor);
      } else {
        this.selectedVendors.push(vendor);
      }
    } else {
      vendor.isChecked = false;
      const index = this.selectedVendors.indexOf(vendor);
      this.selectedVendors.splice(index, 1);
    }
  }

  onChangeAccountCustomRule(account) {
    if ((this.isPaymentMethod && account.defaultPaymentMethods.length > 0) || (this.isPaymentTerm && account.defaultPaymentTerms.length > 0)) {
      account.isChecked = true;
      account.preferredPaymentName = this.allPaymentTerms?.filter(t => t.id == account.preferredPayment).map(term => term.name)[0];
      account.preferredMethodName = this.allPaymentMethods?.filter(m => m.id == account.preferredMethod).map(method => method.name)[0];
      const exists = this.selectedAccounts?.filter((a: any) => a.id == account.id)[0];
      if (exists) {
        const index = this.selectedAccounts.indexOf(account);
        this.selectedAccounts.splice(index, 1);
        this.selectedAccounts.push(account);
      } else {
        this.selectedAccounts.push(account);
      }
    } else {
      account.isChecked = false;
      const index = this.selectedAccounts.indexOf(account);
      this.selectedAccounts.splice(index, 1);
    }
  }

  // setExistingzTermId(vendor,element){
  //   const isVendor = this.allVendors?.filter((v:any)=> v.id==vendor.id)[0];
  //   const id = isVendor?.vendorPaymentTerm?.filter(term=> term.paymentTermId==element.id).map(ter=> ter.id)[0];
  //   return id;
  // }

  setBulkPaymentTerms() {
    const terms = [];
    this.selectedVendors.forEach((vendor: any) => {
      vendor.defaultPaymentTerms?.forEach(element => {
        const termEach = {
          id: 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          vendorId: vendor.id,
          paymentTermId: element.id,
          statusId: Status.ACTIVE,
          isDefault: (element.id == vendor.preferredPayment ? true : false)
        }
        terms.push(termEach);
      });
    });
    // console.log(terms)
    return terms;
  }

  setAccountBulkPaymentTerms() {
    const terms = [];
    this.selectedAccounts.forEach((account: any) => {
      account.defaultPaymentTerms?.forEach(element => {
        const termEach = {
          id: 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          accountId: account.id,
          paymentTermId: element.id,
          statusId: Status.ACTIVE,
          isDefault: (element.id == account.preferredPayment ? true : false),
          paymentTermName: element.name
        }
        terms.push(termEach);
      });
    });
    // console.log(terms)
    return terms;
  }

  setBulkPaymentMethods() {
    const terms = [];
    this.selectedVendors?.forEach((vendor: any) => {
      vendor.defaultPaymentMethods?.forEach(element => {
        const termEach = {
          id: 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          vendorId: vendor.id,
          paymentMethodId: element.id,
          statusId: Status.ACTIVE,
          isDefault: (element.id == vendor.preferredMethod ? true : false)
        }
        terms.push(termEach);
      });
    });
    return terms;
  }

  setAccountBulkPaymentMethods() {
    const terms = [];
    this.selectedAccounts?.forEach((account: any) => {
      account.defaultPaymentMethods?.forEach(element => {
        const termEach = {
          id: 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          accountId: account.id,
          paymentMethodId: element.id,
          statusId: Status.ACTIVE,
          isDefault: (element.id == account.preferredMethod ? true : false),
          paymentMethodName: element.name
        }
        terms.push(termEach);
      });
    });
    // console.log(terms)
    return terms;
  }

  saveBulkVendorCustomRules() {
    this.isDisabled = true;
    if (this.isPaymentTerm) {
      const req = this.setBulkPaymentTerms();
      this.customRuleService.updateBulkPaymentTermVendor(req).then(() => {
        this.displayVendorTB = false;
        this.isDisabled = false;
        this.selectedVendors = [];
        this.loadCustomRules();
        this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: "Custom Rule updated successfully..." });
      })
        .catch((error) => {
          this.isDisabled = false;
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: "Error in saving data..." });
        });
    } else {
      const req = this.setBulkPaymentMethods();
      this.customRuleService.updateBulkPaymentMethodVendor(req).then(() => {
        this.displayVendorTB = false;
        this.isDisabled = false;
        this.selectedVendors = [];
        this.loadCustomRules();
        this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: "Custom Rule updated successfully..." });
      })
        .catch((error) => {
          this.isDisabled = false;
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: "Error in saving data..." });
        });
    }
  }

  saveBulkAccountCustomRules() {
    this.isDisabled = true;
    if (this.isPaymentTerm) {
      const req = this.setAccountBulkPaymentTerms();
      this.customRuleService.updateBulkPaymentTermAccount(req).then(() => {
        this.displayAccountTB = false;
        this.isDisabled = false;
        this.selectedVendors = [];
        this.loadCustomRules();
        this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: "Custom Rule updated successfully..." });
      })
        .catch((error) => {
          this.isDisabled = false;
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: "Error in saving data..." });
        });
    } else {
      const req = this.setAccountBulkPaymentMethods();
      this.customRuleService.updateBulkPaymentMethodAccount(req).then(() => {
        this.displayAccountTB = false;
        this.isDisabled = false;
        this.selectedVendors = [];
        this.loadCustomRules();
        this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: "Custom Rule updated successfully..." });
      })
        .catch((error) => {
          this.isDisabled = false;
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: "Error in saving data..." });
        });
    }
  }

}
